const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export async function fetchBitcoinPrice() {
	const response = await fetch(`${API_BASE_URL}/api/BitcoinInfo/prices`);
	if (!response.ok) {
		throw new Error("Failed to fetch Bitcoin price");
	}
	return await response.json();
}

export async function fetchRecommendedFees() {
	const response = await fetch(`${API_BASE_URL}/api/BitcoinInfo/fees`);
	if (!response.ok) {
		throw new Error("Failed to fetch recommended fees");
	}
	return await response.json();
}
